
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"20","height":"16","viewBox":"0 0 20 16","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M18.125.5H1.875C.839.5 0 1.34 0 2.375v11.25C0 14.661.84 15.5 1.875 15.5h16.25c1.035 0 1.875-.84 1.875-1.875V2.375C20 1.339 19.16.5 18.125.5zm0 1.875v1.594c-.876.713-2.272 1.822-5.257 4.16-.658.517-1.961 1.76-2.868 1.746-.907.014-2.21-1.229-2.868-1.746-2.984-2.337-4.381-3.447-5.257-4.16V2.375h16.25zm-16.25 11.25v-7.25c.895.713 2.164 1.713 4.1 3.228.853.672 2.348 2.156 4.025 2.147 1.669.009 3.145-1.453 4.025-2.146a664.637 664.637 0 004.1-3.229v7.25H1.875z","fill":"#0B0E1F"}})])
          )
        }
      }
    